import { includes } from 'lib/helpers/array';
import { ISOLang, supportedISO639_1Languages } from 'types';

export const BCPtoISOLanguage = (code: string): ISOLang | null => {

  const language = code.substring(0, 2);
  return includes(supportedISO639_1Languages, language) ? language : null;

};
